import createActionTypes from './createActionTypes';

export const namespace = 'TAGS';

export const types = createActionTypes(namespace, [
  'SEARCH',
  'CLICK_BUTTON',
  'VIDEO_START',
  'VIDEO_STEP',
  'ADD_VISIBLE_TAG_ID',
  'REMOVE_VISIBLE_TAG_ID',
  'SET_SELECTED_VARIANT_INDEX',
]);

export const search = (query) => ({
  type: types.SEARCH,
  payload: { query },
});

export const clickButton = (button, tagId, flyerId, storeId) => ({
  type: types.CLICK_BUTTON,
  payload: {
    button,
    tagId,
    flyerId,
    storeId,
  },
});

export const tagVideoStart = (payload) => ({
  type: types.VIDEO_START,
  payload,
});

export const tagVideoStep = (payload) => ({
  type: types.VIDEO_STEP,
  payload,
});

export const addVisibleTagId = (tagId) => ({
  type: types.ADD_VISIBLE_TAG_ID,
  payload: {
    tagId,
  },
});

export const removeVisibleTagId = (tagId) => ({
  type: types.REMOVE_VISIBLE_TAG_ID,
  payload: {
    tagId,
  },
});

export const setSelectedVariantIndex = (activeParentTagId, selectedVariantIndex) => ({
  type: types.SET_SELECTED_VARIANT_INDEX,
  payload: {
    activeParentTagId,
    selectedVariantIndex,
  },
});
